import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '@react/react-spectrum/Button';
import { cloneIcon } from '@react/react-spectrum/utils/icon';
import '../scss/base.scss';

export default class HeaderNameComponent extends Component {
    static propTypes = {
        /**
		 * An Icon to render with HeaderNameComponent
		 */
        icon: PropTypes.element,

    	/**
		 * Name of header to be Displayed
		 */
        headerName: PropTypes.string.isRequired,

    	/**
		 * Should the icon be clickable
		 */
        isClickable: PropTypes.bool,

    	/**
		 * Callback if icon is clickable
		 */
    	onClick: (props, propName) => {
    		if (props.isClickable === true && (props[propName] === undefined || typeof props[propName] !== 'function')) {
    			return new Error(`${propName} Validation Failed`);
    		}
    		return null;
        },
    }

    static defaultProps = {
        isClickable: false,
        icon: null,
    	onClick: null,
    };

    render() {
    	const {
    		icon,
    		headerName,
    		isClickable,
    		className,
    		onClick,
    		...otherProps
    	} = this.props;

    	return (
            <div
                className={classNames('headerName-wrapper', className)}
                {...otherProps}>
    			{!isClickable && cloneIcon(icon, { className: 'headerName-wrapper-icon' })}
    			{isClickable
				&& (
				    <Button
				        label={null}
				        onClick={onClick}
				        quiet
				        variant="action"
				        icon={icon}
				        className={classNames('headerName-wrapper', 'headerName-wrapper-icon')} />
				)}
    			<span className="headerName-wrapper-text">{headerName}</span>
            </div>
    	);
    }
}
